import { Component, Vue } from "vue-property-decorator";

@Component
export default class Notifications extends Vue {
  public menu = false;
  public showUnreadOnly = false;
}